import axios from "axios";
import { api } from "../services/config";
import qs from "qs";

export function getCookie(name) {
    var cookieValue = null;
    if (document.cookie && document.cookie !== "") {
        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === name + "=") {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

export function isObjectEmpty(obj) {
    for (let i in obj) return false;
    return true;
}

export function checkError(response) {
    if (response.status >= 200 && response.status <= 299) {
        return response.data;
    } else {
        throw Error(response.statusText);
    }
}

export const onShowMessage = (setShow, setMessage) => {
    setShow(true);
    window.setTimeout(() => {
        setShow(false);
        setMessage("");
    }, 5000);
};

export async function getDataFromFile(
    type,
    acceptedFiles,
    projectId,
    setIsLoading,
    setMessage,
    setShowError,
    setShowSuccess,
    params,
    docMessage,
    navigate
) {
    setMessage("");
    if (acceptedFiles[0] !== undefined) {
        const csrftoken = getCookie("csrftoken");
        setIsLoading(true);
        setMessage("");

        let data = new FormData();
        for (const file of acceptedFiles) {
            data.append("files", file);
        }
        data.append("type", type);

        if (type === "docs") {
            if (!isObjectEmpty(params.extraction)) {
                data.append("label", params.label);
                if (params.lang !== 0) data.append("language", params.lang);
                for (const [key, value] of Object.entries(params.extraction)) {
                    data.append(key, value);
                }
            }
        } else {
            data.append("label", params.label);
            if (params.lang !== 0) data.append("language", params.lang);
        }

        await axios
            .post(api.project + projectId + "/upload/", data, {
                headers: {
                    "X-CSRFToken": csrftoken,
                    "Content-Type": "multipart/form-data",
                },
            })
            .then(checkError)
            .then((res) => {
                setIsLoading(false);
                const message = !docMessage ? (
                    <span>
                        {res.count === 1 ? "1 fichier a" : `${res.count} fichiers ont`} été
                        correctement <b>chargés</b>. Veuillez consulter la page de{" "}
                        <span className="link_text" onClick={() => navigate("/tasks/")}>
                            Status des tâches
                        </span>{" "}
                        pour suivre l'avancement de l'import.
                    </span>
                ) : (
                    <span>
                        {res.count === 1 ? "1 fichier a" : `${res.count} fichiers ont`} été
                        correctement <b>chargés</b>. Ce traitement va prendre du temps,
                        vérifier régulièrement en allant sur{" "}
                        <span className="link_text" onClick={() => navigate("/tasks/")}>
                            Status des tâches
                        </span>
                    </span>
                );
                setMessage(message);
                onShowMessage(setShowSuccess, setMessage);
            })

            .catch((res) => {
                setIsLoading(false);
                setMessage(
                    res?.response?.data?.message_fr
                        ? `Une erreur est survenue lors du chargement du fichier. ${res?.response?.data?.message_fr}`
                        : "Le serveur ne répond pas."
                );
                setShowError(true);
                console.log(res?.response?.data?.message_fr);
            });
    }
}

export async function fetchTypeAheadTerms(
    projectId,
    params,
    setTerms,
    setLoading,
    limit = 5,
    offset = 0
) {
    const csrftoken = getCookie("csrftoken");
    params["offset"] = offset;
    params["limit"] = limit;

    await axios
        .get(
            `${api.project}${projectId}/terms/`,
            {
                params,
                paramsSerializer: function (params) {
                    return qs.stringify(params, { arrayFormat: "repeat" });
                },
            },
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrftoken,
                },
            }
        )
        .then((res) => {
            setTerms(res.data.terms);
            setLoading(true);
        })
        .catch(function (error) {
            return Promise.reject(error);
        });
}

export function isEmpty(obj) {
    for (let i in obj) return false;
    return true;
}

export const sortOrderMapping = {
    referenceId: "reference",
    lemma: "form__lemma",
    posTagging: "form__posTagging",
    relevanceScore: "form__relevanceScore",
    exp_pdty: "properties__exppdt",
    head_pdty: "properties__headpdt",
    expansion: "properties__expansion__reference",
    nth_head: "properties__headTerm__reference",
    words: "properties__words",
    documents: "properties__n_doc",
    occurences: "properties__occurences",
};

export function getSort(sortOrder) {
    const sortFields = sortOrder.map((order) => {
        const fieldPrefix = order.direction === "desc" ? "-" : "";
        const sortField = sortOrderMapping[order.name];

        if (sortField) {
            return fieldPrefix + sortField;
        }
        return null;
    });

    const validSortFields = sortFields.filter((field) => field);

    return validSortFields;
}

export function compareObjects(obj1, obj2) {
    if (
        typeof obj1 !== "object" ||
        obj1 === null ||
        typeof obj2 !== "object" ||
        obj2 === null
    ) {
        return false;
    }

    const obj1Keys = Object.keys(obj1);
    const obj2Keys = Object.keys(obj2);
    if (obj1Keys.length !== obj2Keys.length) {
        return false;
    }

    for (let i = 0; i < obj1Keys.length; i++) {
        const key = obj1Keys[i];
        const val1 = obj1[key];
        const val2 = obj2[key];

        if (Array.isArray(val1) && Array.isArray(val2)) {
            if (val1.length !== val2.length) {
                return false;
            }

            for (let j = 0; j < val1.length; j++) {
                if (val1[j] !== val2[j]) {
                    return false;
                }
            }
        } else if (val1 !== val2) {
            return false;
        }
    }

    return true;
}

export const labelDisplayedRows = ({ from, to, count }) => {
    return `${from}–${to} sur ${count}`;
};

export function paramsSerializer(params) {
    return qs.stringify(params);
}

export function nDigits(numberString, n) {
    const numberLength = numberString.length;
    if (numberLength < n) return 0;
    return Number(numberString.substring(0, numberLength - n + 1));
}
